import { OnboardingStepType, useCompleteOnboardingStep } from '@alice-financial/alice-sdk'
import { Button } from '@alice-financial/pretext-ui'
import * as React from 'react'

type CompleteOnboardingStepButtonProps = {
  orgId: number
  stepType: OnboardingStepType
  dataChange: string
  label: string
  variant?: 'text' | 'outlined' | 'contained'
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  disabled?: boolean
  onClick?: () => void
}

export const CompleteOnboardingStepButton = ({
  orgId,
  stepType,
  dataChange,
  label,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  onClick,
}: CompleteOnboardingStepButtonProps) => {
  const { mutate: completeStep, isLoading } = useCompleteOnboardingStep(orgId)

  const handleClick = () => {
    if (onClick) {
      onClick()
    }

    completeStep({
      stepType,
      dataChange,
    })
  }

  return (
    <Button variant={variant} color={color} disabled={disabled || isLoading} onClick={handleClick}>
      {label}
    </Button>
  )
}
